import { createUseStyles } from 'react-jss'

import { red } from '../../../../../../../../../../styles/const/colors'

const useStyles = createUseStyles(theme => ({
  textCenter: {
    textAlign: 'center'
  },
  remainingBudget: {
    width: 100
  },
  hasError: {
    '& input': {
      borderColor: red
    }
  },
  capitalize: {
    textTransform: 'capitalize'
  }
}))

export default useStyles
